import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as moment_ from 'moment';
import { NavigationService } from '../NavigationService/navigation-service.service';
const moment = moment_;

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  constructor(private _snackBar: MatSnackBar, private naviationService: NavigationService, public router: Router) { }

  openSnackBar(message: string, url: string) {
    const snackBarRef = this._snackBar.open(message, 'Show', {
      duration: 5000,
      panelClass: 'custom-snackbar',
    });

    snackBarRef.onAction().subscribe(() => {
      this.navigate(url);
    });
  }

  public async navigate(url: string) {
    this.router.navigateByUrl(url, { skipLocationChange: false })
  }
}
